import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../Features/authSlice";
import notificationReducer from "../Features/notificationSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    notification: notificationReducer,
  },
});
